import { compose, getContext } from 'recompose'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { fetchAirDna } from 'src/actions/airDna'
import { selectParamsMap } from 'src/store/selectors/airDna'

const AddressFormContainer = compose(
  injectIntl,
  getContext({
    stateKey: PropTypes.string.isRequired
  }),
  connect(
    (state, { stateKey }) => ({
      ...(selectParamsMap(state)[stateKey] || {})
    }),
    (dispatch, { stateKey }) => ({
      fetch: params => dispatch(fetchAirDna(stateKey, params))
    })
  )
)

export default AddressFormContainer
